// extracted by mini-css-extract-plugin
export var legendIndicator = "_d3-1";
export var legendRight = "_d3-0";